import * as React from 'react'
import { Select } from "./select.component"

const inseeData = [{
  label: 'Europe',
  options: [
    { value: '99125', label: "ALBANIE" },
    { value: '99109', label: "ALLEMAGNE" },
    { value: '99130', label: "ANDORRE" },
    { value: '99135', label: "ARUBA" },
    { value: '99110', label: "AUTRICHE" },
    { value: '99131', label: "BELGIQUE" },
    { value: '99148', label: "BIELORUSSIE" },
    { value: '99118', label: "BOSNIE-HERZEGOVINE" },
    { value: '99103', label: "BOUVET (ILE)" },
    { value: '99111', label: "BULGARIE" },
    { value: '99119', label: "CROATIE" },
    { value: '99101', label: "DANEMARK" },
    { value: '99134', label: "ESPAGNE" },
    { value: '99106', label: "ESTONIE" },
    { value: '99156', label: "MACEDOINE DU NORD" },
    { value: '99101', label: "FEROE (ILES)" },
    { value: '99105', label: "FINLANDE" },
    { value: '99100', label: "FRANCE" },
    { value: '99133', label: "GIBRALTAR" },
    { value: '99126', label: "GRECE" },
    { value: '99132', label: "GUERNESEY" },
    { value: '99112', label: "HONGRIE" },
    { value: '99136', label: "IRLANDE, ou EIRE" },
    { value: '99102', label: "ISLANDE" },
    { value: '99127', label: "ITALIE" },
    { value: '99132', label: "JERSEY" },
    { value: '99157', label: "KOSOVO" },
    { value: '99107', label: "LETTONIE" },
    { value: '99113', label: "LIECHTENSTEIN" },
    { value: '99108', label: "LITUANIE" },
    { value: '99137', label: "LUXEMBOURG" },
    { value: '99144', label: "MALTE" },
    { value: '99132', label: "MAN (ILE)" },
    { value: '99151', label: "MOLDAVIE" },
    { value: '99138', label: "MONACO" },
    { value: '99120', label: "MONTENEGRO" },
    { value: '99103', label: "NORVEGE" },
    { value: '99135', label: "PAYS-BAS" },
    { value: '99122', label: "POLOGNE" },
    { value: '99139', label: "PORTUGAL" },
    { value: '99141', label: "REPUBLIQUE DEMOCRATIQUE ALLEMANDE" },
    { value: '99142', label: "REPUBLIQUE FEDERALE D'ALLEMAGNE" },
    { value: '99114', label: "ROUMANIE" },
    { value: '99132', label: "ROYAUME-UNI" },
    { value: '99123', label: "RUSSIE" },
    { value: '99128', label: "SAINT-MARIN" },
    { value: '99121', label: "SERBIE" },
    { value: '99117', label: "SLOVAQUIE" },
    { value: '99145', label: "SLOVENIE" },
    { value: '99104', label: "SUEDE" },
    { value: '99140', label: "SUISSE" },
    { value: '99103', label: "SVALBARD et ILE JAN MAYEN" },
    { value: '99115', label: "TCHECOSLOVAQUIE" },
    { value: '99116', label: "TCHEQUIE" },
    { value: '99124', label: "TURQUIE D'EUROPE" },
    { value: '99155', label: "UKRAINE" },
    { value: '99129', label: "VATICAN, ou SAINT-SIEGE" }
  ]
}, {
  label: 'Asie',
  options: [
    { value: '99212', label: "AFGHANISTAN" },
    { value: '99201', label: "ARABIE SAOUDITE" },
    { value: '99252', label: "ARMENIE" },
    { value: '99253', label: "AZERBAIDJAN" },
    { value: '99249', label: "BAHREIN" },
    { value: '99246', label: "BANGLADESH" },
    { value: '99214', label: "BHOUTAN" },
    { value: '99224', label: "BIRMANIE" },
    { value: '99225', label: "BRUNEI" },
    { value: '99234', label: "CAMBODGE" },
    { value: '99216', label: "CHINE" },
    { value: '99254', label: "CHYPRE" },
    { value: '99237', label: "COREE" },
    { value: '99239', label: "COREE (REPUBLIQUE DE)" },
    { value: '99238', label: "COREE (REPUBLIQUE POPULAIRE DEMOCRATIQUE DE)" },
    { value: '99247', label: "EMIRATS ARABES UNIS" },
    { value: '99228', label: "ETATS MALAIS NON FEDERES" },
    { value: '99255', label: "GEORGIE" },
    { value: '99223', label: "GOA" },
    { value: '99230', label: "HONG-KONG" },
    { value: '99223', label: "INDE" },
    { value: '99231', label: "INDONESIE" },
    { value: '99204', label: "IRAN" },
    { value: '99203', label: "IRAQ" },
    { value: '99207', label: "ISRAEL" },
    { value: '99217', label: "JAPON" },
    { value: '99222', label: "JORDANIE" },
    { value: '99211', label: "KAMTCHATKA" },
    { value: '99256', label: "KAZAKHSTAN" },
    { value: '99257', label: "KIRGHIZISTAN" },
    { value: '99240', label: "KOWEIT" },
    { value: '99241', label: "LAOS" },
    { value: '99205', label: "LIBAN" },
    { value: '99232', label: "MACAO" },
    { value: '99227', label: "MALAISIE" },
    { value: '99229', label: "MALDIVES" },
    { value: '99218', label: "MANDCHOURIE" },
    { value: '99242', label: "MONGOLIE" },
    { value: '99215', label: "NEPAL" },
    { value: '99250', label: "OMAN" },
    { value: '99258', label: "OUZBEKISTAN" },
    { value: '99213', label: "PAKISTAN" },
    { value: '99261', label: "PALESTINE (Etat de)" },
    { value: '99220', label: "PHILIPPINES" },
    { value: '99221', label: "POSSESSIONS BRITANNIQUES AU PROCHE-ORIENT" },
    { value: '99248', label: "QATAR" },
    { value: '99209', label: "SIBERIE" },
    { value: '99226', label: "SINGAPOUR" },
    { value: '99235', label: "SRI LANKA" },
    { value: '99206', label: "SYRIE" },
    { value: '99259', label: "TADJIKISTAN" },
    { value: '99236', label: "TAIWAN" },
    { value: '99219', label: "THAILANDE" },
    { value: '99262', label: "TIMOR ORIENTAL" },
    { value: '99210', label: "TURKESTAN RUSSE" },
    { value: '99260', label: "TURKMENISTAN" },
    { value: '99208', label: "TURQUIE" },
    { value: '99243', label: "VIET NAM" },
    { value: '99244', label: "VIET NAM DU NORD" },
    { value: '99245', label: "VIET NAM DU SUD" },
    { value: '99251', label: "YEMEN" },
    { value: '99233', label: "YEMEN DEMOCRATIQUE" },
    { value: '99202', label: "YEMEN (REPUBLIQUE ARABE DU)" }
  ]
}, {
  label: 'Afrique',
  options: [
    { value: '99319', label: "ACORES, MADERE" },
    { value: '99303', label: "AFRIQUE DU SUD" },
    { value: '99352', label: "ALGERIE" },
    { value: '99395', label: "ANGOLA" },
    { value: '99327', label: "BENIN" },
    { value: '99347', label: "BOTSWANA" },
    { value: '99331', label: "BURKINA" },
    { value: '99321', label: "BURUNDI" },
    { value: '99322', label: "CAMEROUN" },
    { value: '99305', label: "CAMEROUN ET TOGO" },
    { value: '99313', label: "CANARIES (ILES)" },
    { value: '99396', label: "CAP-VERT" },
    { value: '99323', label: "CENTRAFRICAINE (REPUBLIQUE)" },
    { value: '99397', label: "COMORES" },
    { value: '99324', label: "CONGO" },
    { value: '99312', label: "CONGO (REPUBLIQUE DEMOCRATIQUE)" },
    { value: '99326', label: "COTE D'IVOIRE" },
    { value: '99399', label: "DJIBOUTI" },
    { value: '99301', label: "EGYPTE" },
    { value: '99317', label: "ERYTHREE" },
    { value: '99391', label: "ESWATINI" },
    { value: '99315', label: "ETHIOPIE" },
    { value: '99328', label: "GABON" },
    { value: '99304', label: "GAMBIE" },
    { value: '99329', label: "GHANA" },
    { value: '99330', label: "GUINEE" },
    { value: '99314', label: "GUINEE EQUATORIALE" },
    { value: '99392', label: "GUINEE-BISSAU" },
    { value: '99320', label: "ILES PORTUGAISES DE L'OCEAN INDIEN" },
    { value: '99332', label: "KENYA" },
    { value: '99348', label: "LESOTHO" },
    { value: '99302', label: "LIBERIA" },
    { value: '99316', label: "LIBYE" },
    { value: '99333', label: "MADAGASCAR" },
    { value: '99334', label: "MALAWI" },
    { value: '99335', label: "MALI" },
    { value: '99350', label: "MAROC" },
    { value: '99390', label: "MAURICE" },
    { value: '99336', label: "MAURITANIE" },
    { value: '99393', label: "MOZAMBIQUE" },
    { value: '99311', label: "NAMIBIE" },
    { value: '99337', label: "NIGER" },
    { value: '99338', label: "NIGERIA" },
    { value: '99308', label: "OCEAN INDIEN (TERRITOIRE BRITANNIQUE DE L')" },
    { value: '99339', label: "OUGANDA" },
    { value: '99313', label: "PRESIDES" },
    { value: '99313', label: "PROVINCES ESPAGNOLES D'AFRIQUE" },
    { value: '99340', label: "RWANDA" },
    { value: '99389', label: "SAHARA OCCIDENTAL" },
    { value: '99306', label: "SAINTE HELENE, ASCENSION ET TRISTAN DA CUNHA" },
    { value: '99394', label: "SAO TOME-ET-PRINCIPE" },
    { value: '99341', label: "SENEGAL" },
    { value: '99398', label: "SEYCHELLES" },
    { value: '99342', label: "SIERRA LEONE" },
    { value: '99318', label: "SOMALIE" },
    { value: '99343', label: "SOUDAN" },
    { value: '99307', label: "SOUDAN ANGLO-EGYPTIEN, KENYA, OUGANDA" },
    { value: '99349', label: "SOUDAN DU SUD" },
    { value: '99325', label: "TANGER" },
    { value: '99309', label: "TANZANIE" },
    { value: '99344', label: "TCHAD" },
    { value: '99345', label: "TOGO" },
    { value: '99351', label: "TUNISIE" },
    { value: '99346', label: "ZAMBIE" },
    { value: '99308', label: "ZANZIBAR" },
    { value: '99310', label: "ZIMBABWE" }
  ]
}, {
  label: 'Amérique',
  options: [
    { value: '99404', label: "ALASKA" },
    { value: '99425', label: "ANGUILLA" },
    { value: '99441', label: "ANTIGUA-ET-BARBUDA" },
    { value: '99431', label: "ANTILLES NEERLANDAISES" },
    { value: '99415', label: "ARGENTINE" },
    { value: '99436', label: "BAHAMAS" },
    { value: '99434', label: "BARBADE" },
    { value: '99429', label: "BELIZE" },
    { value: '99425', label: "BERMUDES" },
    { value: '99418', label: "BOLIVIE" },
    { value: '99443', label: "BONAIRE, SAINT EUSTACHE ET SABA" },
    { value: '99416', label: "BRESIL" },
    { value: '99425', label: "CAIMANES (ILES)" },
    { value: '99401', label: "CANADA" },
    { value: '99417', label: "CHILI" },
    { value: '99419', label: "COLOMBIE" },
    { value: '99406', label: "COSTA RICA" },
    { value: '99407', label: "CUBA" },
    { value: '99444', label: "CURAÇAO" },
    { value: '99408', label: "DOMINICAINE (REPUBLIQUE)" },
    { value: '99438', label: "DOMINIQUE" },
    { value: '99414', label: "EL SALVADOR" },
    { value: '99420', label: "EQUATEUR" },
    { value: '99404', label: "ETATS-UNIS" },
    { value: '99427', label: "GEORGIE DU SUD ET LES ILES SANDWICH DU SUD" },
    { value: '99435', label: "GRENADE" },
    { value: '99430', label: "GROENLAND" },
    { value: '99409', label: "GUATEMALA" },
    { value: '99428', label: "GUYANA" },
    { value: '99410', label: "HAITI" },
    { value: '99411', label: "HONDURAS" },
    { value: '99426', label: "JAMAIQUE" },
    { value: '99403', label: "LABRADOR" },
    { value: '99427', label: "MALOUINES, OU FALKLAND (ILES)" },
    { value: '99405', label: "MEXIQUE" },
    { value: '99425', label: "MONTSERRAT" },
    { value: '99412', label: "NICARAGUA" },
    { value: '99413', label: "PANAMA" },
    { value: '99421', label: "PARAGUAY" },
    { value: '99422', label: "PEROU" },
    { value: '99432', label: "PORTO RICO" },
    { value: '99442', label: "SAINT-CHRISTOPHE-ET-NIEVES" },
    { value: '99439', label: "SAINTE-LUCIE" },
    { value: '99445', label: "SAINT-MARTIN (PARTIE NEERLANDAISE)" },
    { value: '99440', label: "SAINT-VINCENT-ET-LES GRENADINES" },
    { value: '99437', label: "SURINAME" },
    { value: '99432', label: "TERR. DES ETATS-UNIS D'AMERIQUE EN AMERIQUE" },
    { value: '99427', label: "TERR. DU ROYAUME-UNI DANS L'ATLANTIQUE SUD" },
    { value: '99402', label: "TERRE-NEUVE" },
    { value: '99425', label: "TERRITOIRES DU ROYAUME-UNI AUX ANTILLES" },
    { value: '99433', label: "TRINITE-ET-TOBAGO" },
    { value: '99425', label: "TURKS ET CAIQUES (ILES)" },
    { value: '99423', label: "URUGUAY" },
    { value: '99424', label: "VENEZUELA" },
    { value: '99425', label: "VIERGES BRITANNIQUES (ILES)" },
    { value: '99432', label: "VIERGES DES ETATS-UNIS (ILES)" }
  ]
}, {
  label: 'Océanie',
  options: [
    { value: '99501', label: "AUSTRALIE" },
    { value: '99501', label: "CHRISTMAS (ILE)" },
    { value: '99501', label: "COCOS ou KEELING (ILES)" },
    { value: '99502', label: "COOK (ILES)" },
    { value: '99508', label: "FIDJI" },
    { value: '99505', label: "GUAM" },
    { value: '99504', label: "HAWAII (ILES)" },
    { value: '99501', label: "HEARD ET MACDONALD (ILES)" },
    { value: '99513', label: "KIRIBATI" },
    { value: '99505', label: "MARIANNES DU NORD (ILES)" },
    { value: '99515', label: "MARSHALL (ILES)" },
    { value: '99516', label: "MICRONESIE (ETATS FEDERES DE)" },
    { value: '99507', label: "NAURU" },
    { value: '99502', label: "NIUE" },
    { value: '99501', label: "NORFOLK (ILE)" },
    { value: '99502', label: "NOUVELLE-ZELANDE" },
    { value: '99517', label: "PALAOS (ILES)" },
    { value: '99510', label: "PAPOUASIE-NOUVELLE-GUINEE" },
    { value: '99503', label: "PITCAIRN (ILE)" },
    { value: '99512', label: "SALOMON (ILES)" },
    { value: '99505', label: "SAMOA AMERICAINES" },
    { value: '99506', label: "SAMOA OCCIDENTALES" },
    { value: '99505', label: "TERR. DES ETATS-UNIS D'AMERIQUE EN OCEANIE" },
    { value: '99502', label: "TOKELAU" },
    { value: '99509', label: "TONGA" },
    { value: '99511', label: "TUVALU" },
    { value: '99514', label: "VANUATU" }
  ]
}]

interface Props {
  id?: string
  inseeCode: string
  placeholder?: string
  onChange: (inseeCode: string) => void
}

export default function InseeCountryCodeInputComponent ({ inseeCode, onChange, ...otherProps }: Props) {
  return <Select
    { ...otherProps }
    value={ inseeData.flatMap(_ => _.options).find(_ => _.value === inseeCode) }
    options={ inseeData }
    onChange={ val => onChange(val.value) } />
}

export function isInseeFranceCountryCode (code: string) {
  return code === '99100'
}
